import { faPersonChalkboard } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, ButtonType } from "components/Button/Button";
import ContactDetails from "components/ContactDetails/ContactDetails";
import { DataFetcher } from "components/DataFetcher";
import Pod from "components/Pod/Pod";
import useBranding from "hooks/useBranding";
import { useState } from "react";
import "./Help.scss";

const Help = () => {
	const { contactDetails } = useBranding();
	const guruUrls = (sessionStorage.gurus) ? JSON.parse(sessionStorage.gurus) : [];
	const fetchData = { url: "/api/v3/UpsoldFlag" };
	const [data, setData] = useState(null);
	let showContactDetails = [contactDetails.Number, contactDetails.Email].some(value => value && value.trim() !== ""); 

	const renderGuruBlocks = () => {
		if (!guruUrls.length) {
			return null;
		}
		if (guruUrls.length === 1 && guruUrls[0].UserHasGuru) {
			return <div className="help-guru" data-test-id="help-main-gurus">
				<FontAwesomeIcon icon={faPersonChalkboard} className="fa-4x" />
				<p>Need expert help with a part of your phone system? Book a free 1 to 1 guru session here.</p>
				<Button type={ButtonType.Primary} to={guruUrls[0].GuruUrl} text="Book Session" newTab data-test-id="help-main-gurus-button" />
			</div>;
		}

		return (guruUrls.map(guru => (
			guru.UserHasGuru && (
				<div className="help-guru" key={guru.Id} data-test-id="help-main-gurus">
					<FontAwesomeIcon icon={faPersonChalkboard} className="fa-4x" />
					<p>Need expert help with a part of your {guru.Name} phone system? Book a free 1 to 1 guru session here.</p>
					<Button type={ButtonType.Primary} to={guruUrls[0].GuruUrl} text="Book Session" newTab data-test-id="help-main-gurus-button" />
				</div>
			)
		)));
	};

	return (
		<div className={`help gutters ${showContactDetails ? "grid-two-col" : ""}`}>
			<Pod title="Help" data-test-id="help-main-pod">
				<DataFetcher fetchData={fetchData} setData={setData}>
					<div className="help-item" data-test-id="help-main-text">
						<p>Our support team are always happy to answer any questions you have about the site or your subscription, please call us during UK business hours or email any time using the contact details on this page.</p>
						{data && <p>Should you wish to cancel your access to any ucSKILLS training content, please email the iTEL ucSKILLS support team with the subject line "Cancel Access", detailing the specifics of your cancellation request.</p>}
					</div>
				</DataFetcher>
				{renderGuruBlocks()}
			</Pod>
			{showContactDetails && (
				<Pod title="Contact Us" data-test-id="help-contactus-pod">
					<ContactDetails
						number={contactDetails.Number}
						email={contactDetails.Email}
						data-test-id="help-contactus-details"
					/>
				</Pod>
			)}
		</div>
	);
};

export default Help;